import { render, staticRenderFns } from "./create-company-modal.vue?vue&type=template&id=678d0013&scoped=true"
import script from "./create-company-modal.vue?vue&type=script&lang=js"
export * from "./create-company-modal.vue?vue&type=script&lang=js"
import style0 from "./create-company-modal.vue?vue&type=style&index=0&id=678d0013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d0013",
  null
  
)

export default component.exports